var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxiosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5A29E4",
    d: "m13.3 3.7-7 5.6H11v18.4l2.4-2v-22zm2 20.4 7-5.8h-4.6V.3L15.3 2v22.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxiosIcon);
export default __webpack_public_path__ + "static/media/axios-icon.b165bd30ded20860f7176b3298c61b76.svg";
export { ForwardRef as ReactComponent };